import { createMachine } from 'xstate'

const emailVerificationMachine = createMachine({
  id: 'emailVerification',
  initial: 'isVerifying',
  states: {
    isVerifying: {
      on: {
        VERIFIED: 'isVerified',
        NOT_VERIFIED: 'isNotVerified',
        VERIFIED_AND_USER_EXISTS: 'isVerifiedWithUser',
      },
    },
    isVerified: {},
    isNotVerified: {},
    isVerifiedWithUser: {},
  },
})

export default emailVerificationMachine
